var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDoller(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9844 14C25.9844 20.731 20.731 25.9844 14 25.9844C7.269 25.9844 2.01562 20.731 2.01562 14C2.01562 7.26905 7.269 2.01563 14 2.01563C20.731 2.01563 25.9844 7.26905 25.9844 14Z",
    stroke: "white",
    strokeWidth: 2.4,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4.85938V23.1406",
    stroke: "white",
    strokeWidth: 2.4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9844 14H15.0156C16.6984 14 18.0625 15.3641 18.0625 17.0469C18.0625 18.7296 16.6984 20.0938 15.0156 20.0938H12.9844C11.3016 20.0938 9.9375 18.7296 9.9375 17.0469",
    stroke: "white",
    strokeWidth: 2.4,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0156 14H12.9844C11.3016 14 9.9375 12.6359 9.9375 10.9531C9.9375 9.27039 11.3016 7.90625 12.9844 7.90625H15.0156C16.6984 7.90625 18.0625 9.27039 18.0625 10.9531",
    stroke: "white",
    strokeWidth: 2.4,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoller);
export default __webpack_public_path__ + "static/media/icon-doller.13c660eb709d8c1da1d06e42a789fb9e.svg";
export { ForwardRef as ReactComponent };